import React from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

import './style.css';

export default function CarouselLanguage({ items, isDarkMode }) {
  const options = {
    loop: true,
    margin: 10,
    nav: true,
    dots: false,
    autoplay: true,
    autoplayHoverPause: true,
    navText: [
      `<i class='fa fa-arrow-left fa-lg carousel-nav-left  ${
        isDarkMode ? 'carousel-dark-theme-color' : 'carousel-light-theme-color'
      }'></i>`,
      `<i class='fa fa-arrow-right fa-lg carousel-nav-right  ${
        isDarkMode ? 'carousel-dark-theme-color' : 'carousel-light-theme-color'
      }'></i>`,
    ],
    responsive: {
      0: {
        items: 1,
      },
      550: {
        items: 2,
      },
      850: {
        items: 3,
      },
      1200: {
        items: 4,
      },
    },
  };

  return (
    <OwlCarousel {...options}>
      {items.map((item, index) => (
        <React.Fragment key={index}>{React.createElement(item.type, item.props)}</React.Fragment>
      ))}
    </OwlCarousel>
  );
}
